import {createEvent, type Emitter, type Listener} from "react-event-hook";

export type GuideAudioEventPayload =
    | {
          base64Audio: string;
          transcript: string;
          isInitialChunk: boolean;
      }
    | {isComplete: true};

interface Event {
    /**
     * Listen for the "guide-audio-stream" event.
     */
    useGuideAudioStreamListener: Listener<GuideAudioEventPayload>;
    /**
     * Emit the "guide-audio-stream" event.
     */
    emitGuideAudioStream: Emitter<GuideAudioEventPayload>;
}

/**
 * This event is emitted within the ai-guide frontend code whenever the backend
 * streams back an audio chunk.
 *
 * The `useGuideAudioStream` hook listens for these events to handle streamed
 * audio.
 */
export const {useGuideAudioStreamListener, emitGuideAudioStream} = createEvent(
    "guide-audio-stream",
)() as Event;
